var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "washing-machine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.258,
    height: 29.368,
    viewBox: "0 0 25.258 29.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M.5,185.707a1.765,1.765,0,0,0,1.763,1.763H24a1.765,1.765,0,0,0,1.763-1.763V167.723H.5ZM13.13,169.59a6.885,6.885,0,1,1-6.886,6.885A6.893,6.893,0,0,1,13.13,169.59Zm0,0",
    transform: "translate(-0.5 -158.102)",
    fill: "#9b9b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M142.377,319.744a3.452,3.452,0,0,1-2.619-1.262c-.508-.51-.78-.755-1.4-.755s-.891.245-1.4.755a4.124,4.124,0,0,1-1.48,1.063,5.164,5.164,0,0,0,10.049-1.551,4.742,4.742,0,0,0-.536.488A3.449,3.449,0,0,1,142.377,319.744Zm0,0",
    transform: "translate(-127.738 -299.502)",
    fill: "#9b9b9b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M133.827,233.58a3.453,3.453,0,0,1,2.618,1.262c.508.51.78.755,1.4.755s.889-.245,1.4-.755a4.125,4.125,0,0,1,1.48-1.064,5.164,5.164,0,0,0-10.049,1.551,4.743,4.743,0,0,0,.537-.488A3.453,3.453,0,0,1,133.827,233.58Zm0,0",
    transform: "translate(-123.205 -217.076)",
    fill: "#9b9b9b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M25.758,1.763A1.765,1.765,0,0,0,24,0H2.263A1.765,1.765,0,0,0,.5,1.763V7.9H25.758ZM10.581,5.382a.86.86,0,0,1-.86.86H4.11a.86.86,0,0,1-.86-.86V2.62a.86.86,0,0,1,.86-.86h5.61a.86.86,0,0,1,.86.86Zm6.945-.009A1.372,1.372,0,1,1,18.9,4,1.373,1.373,0,0,1,17.526,5.373Zm4.015,0A1.372,1.372,0,1,1,22.913,4,1.373,1.373,0,0,1,21.541,5.373Zm0,0",
    transform: "translate(-0.5)",
    fill: "#9b9b9b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M78.441,60.68h3.89v1.041h-3.89Zm0,0",
    transform: "translate(-73.971 -57.199)",
    fill: "#9b9b9b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWash);
export default __webpack_public_path__ + "static/media/wash.3d47d281213d52d4f0b0cea241c0e6e7.svg";
export { ForwardRef as ReactComponent };